var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canAccessPage)?_c('div',[_c('grupo-tabela',{staticStyle:{"outline":"none"},on:{"GRUPOTABELA_EDITAR":_vm.editar,"GRUPOTABELA_VISUALIZAR":_vm.visualizar}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }